/**
 * 点云几何体的 WebGL 资源封装，记录 VAO 与各属性 VBO。
 */
export class WebGLBuffer {
  /** 可绘制的元素数量（= position.count） */
  numElements: number
  /** 顶点数组对象，绑定全部属性 */
  vao: WebGLVertexArrayObject | null
  /** geometry dispose 监听器，供渲染器关闭时主动解绑 */
  disposeHandler: (() => void) | null
  /** 按属性名索引的 VBO 元信息表 */
  vbos: Map<
    string,
    {
      buffer?: WebGLBuffer | null
      attribute?: any
      handle: globalThis.WebGLBuffer | null
      name: string
      count: number
      itemSize: number
      type: any
      version: number
      /** 最近一次上传到 GL 的字节数，仅用于内存诊断 */
      byteLength: number
    }
  >
  constructor() {
    this.numElements = 0
    this.vao = null
    this.disposeHandler = null
    this.vbos = new Map()
  }
}
